export const timeFormat = "h:mm aa";

export const isDateGreaterThanEqualTo = (
  firstDate: Date | null | undefined,
  secondDate: Date | null | undefined
) => {
  return (
    firstDate &&
    secondDate &&
    new Date(firstDate).setHours(0, 0, 0, 0) >=
      new Date(secondDate).setHours(0, 0, 0, 0)
  );
};

export const isDateEqualTo = (
  firstDate: Date | null | undefined,
  secondDate: Date | null | undefined
) => {
  return (
    firstDate &&
    secondDate &&
    new Date(firstDate).setHours(0, 0, 0, 0) ===
      new Date(secondDate).setHours(0, 0, 0, 0)
  );
};

export const isDateLessThanEqualTo = (
  firstDate: Date | null | undefined,
  secondDate: Date | null | undefined
) => {
  return (
    firstDate &&
    secondDate &&
    new Date(firstDate).setHours(0, 0, 0, 0) <=
      new Date(secondDate).setHours(0, 0, 0, 0)
  );
};

export const formatDateTime = (
  date: Date | string | null | undefined,
  isZeroTimezone: boolean
) => {
  if (!date) return "";

  return `${formatDate(date, isZeroTimezone)} ${formatTime(
    date,
    isZeroTimezone
  )}`;
};

// Epoch ms for ordering by a stored time, read the same way formatDateTime displays it
// (isZeroTimezone: a SoilFLO load time, stored as UTC without a zone marker). Missing
// times sort as the oldest.
export const toTimestamp = (
  date: Date | string | null | undefined,
  isZeroTimezone: boolean
) => {
  if (!date) return 0;
  return new Date(isZeroTimezone ? `${date}Z` : date).getTime();
};

export const formatDate = (
  date: Date | string | null | undefined,
  isZeroTimezone: boolean
) => {
  if (!date) return "";
  if (isZeroTimezone) {
    return new Date(`${date}Z`).toLocaleDateString("en-ZA");
  }
  return new Date(date).toLocaleDateString("en-ZA");
};

export const formatTime = (
  date: Date | string | null | undefined,
  isZeroTimezone: boolean
) => {
  if (!date) return "";

  if (isZeroTimezone) {
    return new Date(`${date}Z`).toLocaleTimeString();
  }
  return new Date(date).toLocaleTimeString();
};

// Prepares a picked or API-returned time for the admin edit view's save. The API sends
// stored times as unzoned local wall-clock ("2026-09-14T10:02:05"); parsing makes the
// browser read that as local time, so it posts as UTC ("...14:02:00.000Z") and the
// server's ToLocalDateTime restores 10:02. Posting the raw string instead makes the
// server read it as UTC and shift it back by the Eastern offset (4 hours in summer).
export const removeSeconds = (date: Date | null) => {
  if (!date) return null;
  let parsedDate = new Date(date);
  parsedDate.setSeconds(0, 0);
  return parsedDate;
};
